export default "__VITE_ASSET__DXCQ7sbF__"